import { round } from "services/helpers"
import { buildPartialTerminationRows, computeTerminationCashTotal, getContractQuantity } from "views/app/OptionEdit/derivativeTerminationUtils"

export const resolveEventDate = ({ terminationPre, values, remainingData } = {}) => (
  terminationPre?.option_state_date
  || values?.option_state_date
  || remainingData?.start_date
  || new Date()
)

const DECIMAL_PLACES = 6
const PRICE_DECIMAL_PLACES = 10

export const parseAmount = (value) => {
  const parsed = parseFloat(String(value ?? "").replace(",", "."))
  return Number.isFinite(parsed) ? parsed : null
}

export const resolveTerminationSettlement = ({
  terminationPre,
  values,
  terminatedQty,
  strikePrice,
  role,
  optionRight,
  derivativeType,
} = {}) => {
  const pickAmount = (primary, secondary) => {
    const first = parseAmount(primary)
    if (first != null && first !== 0) return first
    const second = parseAmount(secondary)
    if (second != null) return second
    return first
  }

  const unitPrice = pickAmount(values?.termination_price, terminationPre?.termination_price)
  const cash = pickAmount(values?.receives, terminationPre?.receives)
  // termination_fee is the unit price. A document may still carry the old strike spread in that field.
  const fee = unitPrice
    ?? pickAmount(values?.termination_fee, terminationPre?.termination_fee)
    ?? 0

  let receives = cash
  if ((receives == null || receives === 0) && unitPrice && terminatedQty && strikePrice != null) {
    const computed = computeTerminationCashTotal({
      quantity: terminatedQty,
      unitPrice,
      strikePrice,
      role,
      optionRight,
      derivativeType,
    })
    receives = computed === "" ? 0 : computed
  }

  return {
    termination_price: round(unitPrice ?? 0, PRICE_DECIMAL_PLACES),
    receives: round(receives ?? 0, PRICE_DECIMAL_PLACES),
    termination_fee: round(fee ?? 0, DECIMAL_PLACES),
  }
}

export const buildPartialTerminationApproval = ({
  linkedOption,
  linkedId,
  remainingData,
  terminationPre,
  values,
  portfolioId,
  formatDateField,
}) => {
  const remainingQty = parseAmount(remainingData?.quantity) ?? 0
  const originalQty = getContractQuantity(linkedOption)
  const terminatedQty = Math.max(round(originalQty - remainingQty, DECIMAL_PLACES), 0)
  const eventDate = resolveEventDate({ terminationPre, values, remainingData })
  const settlement = resolveTerminationSettlement({
    terminationPre,
    values,
    terminatedQty,
    strikePrice: parseAmount(linkedOption?.strike_price),
    role: linkedOption?.role,
    optionRight: linkedOption?.option_right,
    derivativeType: linkedOption?.derivative_type,
  })
  const rows = buildPartialTerminationRows(linkedOption, {
    terminationQuantity: terminatedQty,
    eventDate,
    remainingTradeId: remainingData?.trade_id,
    settlement,
    remainingOverrides: remainingData,
    portfolioId,
    formatDateField,
  })

  return {
    originalId: linkedId,
    originalPatch: rows.originalPatch,
    terminatedCreate: rows.terminatedCreate,
    remainingCreate: rows.remainingCreate,
    terminatedQty,
    eventDate: rows.eventDate,
  }
}
